(function () {
  'use strict';

  angular.module('app').component('exchangeRateCurrencyList', exchangeRateList());

  function exchangeRateList() {
    return {
      bindings: {},
      controller: ExchangeRateListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/exchange-rates/exchange-rate-currency-list/exchange-rate-currency-list.component.html',
    };
  }

  ExchangeRateListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'moment',
    'ExchangeRateService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function ExchangeRateListComponent(
    config,
    UtilService,
    SessionService,
    moment,
    ExchangeRateService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ExchangeRateService.getFilterCriteria();

    vm.dateDisplay = config.DATE_DISPLAY;

    // private properties
    // -----------------------
    let today = moment().startOf('day');

    // console.log( moment('2021-01-10').isBetween('2021-01-10', '2021-01-10', undefined, '[]') );

    /*let setCurrentExchangeRate = (currency) => {
            // console.log(exchangeRate.from);
            return currency.exchange_rates.find(
                exchangeRate => today.isBetween(exchangeRate.from, exchangeRate.to, undefined, '[]')
            ) || null;
        };*/

    let company = SessionService.getSelectedAccountCompany();

    vm.$onInit = function () {
      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    vm.openExchangeRateListModal = function (currency, mode) {
      const successCallback = () => {
        getCurrencies(vm.companyCurrencyIds);
      };

      ExchangeRateService.openExchangeRateListModal(
        currency,
        company.id,
        company.country.code,
        vm.companyBaseCurrency,
        vm.companyTimeZoneUtc,
        mode,
        successCallback
      );
    };

    // private methods
    // -----------------------
    function getCompany() {
      vm.loadingItems = true;
      companyService.getCompany(company.id, { skip_check_role: true }).subscribe((response) => {
        vm.companyId = response.id;
        vm.companyBaseCurrencyId = response.currency_id;

        vm.companyCurrencyIds = response.currency_ids;

        vm.companyTimeZoneUtc = response.time_zone.utc;

        getCurrencies(response.currency_ids);
      });
    }

    function getCurrencies(companyCurrencyIds) {
      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true, //,
        // check_if_used_in_transactions: true

        time_zone_utc: vm.companyTimeZoneUtc,
      };

      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currencies = response;

        vm.companyBaseCurrency = response.find((x) => x.id == vm.companyBaseCurrencyId);
        vm.currencies = response.filter((x) => x.id !== vm.companyBaseCurrencyId);

        vm.loadingItems = false;
      });
    }
  }
})();
